<template>
    <div class="my-3 card card-body bg-dark text-light">
		<router-link to="/time-table"><i class="fas fa-arrow-left"></i> Back</router-link>
        <h1 class="my-3 text-center">Các Bước lấy TKB đã Lưu trong Browser trên trang khác</h1>

        <div>
			<div class="my-5">
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/time-table/move-local-storage-1.png'" alt="TKB hust" />
				</div>
				<div class="row justify-content-center">
					<div>Nếu trang hieupham2k1 sập không dùng được và có 1 trang phụ để dùng tạm</div>
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/time-table/move-local-storage-2.png'" alt="TKB hust" />
				</div>
				<div class="row justify-content-center">
					<div>Và bạn cần lấy TKB đã Lưu trên Browser của trang đã sập</div>
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/time-table/move-local-storage-3.png'" alt="TKB hust" />
				</div>
				<div class="row justify-content-center">
					<div>B1) Vào trang hieupham2k1 đã sập, Nhấn URL và gõ "javascript:"</div>
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/time-table/move-local-storage-4.png'" alt="TKB hust" />
				</div>
				<div class="row justify-content-center mb-3">
					<div>
						B2) Copy đoạn code bên dưới và dán vào URL sau "javascript:":
					</div>
				</div>
				<div class="row justify-content-center">
					<div>
						<span @click="copy(jsCodeForLocalStorage)" class="cursor-pointer">
							{{ jsCodeForLocalStorage }}
						</span>
						<span title="Copy">
							<i @click="copy(jsCodeForLocalStorage)" class="far fa-copy cursor-pointer ml-3"></i>
						</span>
					</div>
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<img class="col-8 my-3" :src="host+'/picture/time-table/move-local-storage-5.png'" alt="TKB hust" />
				</div>
				<div class="row justify-content-center">
					<div>B3) Nhấn Enter sẽ hiện ra TKB được mã hóa</div>
				</div>
				<div class="row justify-content-center">
					<small class="text-warning">
						Lưu ý: Copy cả đoạn mã, nếu thiếu 1 ký tự nào đều khiến giải mã thất bại
					</small>
				</div>
			</div>

			<div class="my-5">
				<div class="row justify-content-center">
					<div>B4) Dán đoạn mã vào đây:</div>
				</div>
				<div class="row justify-content-center">
					<div class="col-8 my-3">
						<input v-model="tkbJson" placeholder="Đoạn code TKB đã copy" type="text" class="form-control" />
					</div>
				</div>
				<div class="row justify-content-center">
					<div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
						<button class="btn btn-outline-primary" @click="exportFile()">
							<i class="fas fa-download mx-1"></i>
							<span title="Xuất ra file Excel để lần sau xem hoặc sửa">
								Xuất file
							</span>
						</button>
						<button class="btn btn-outline-primary" @click="saveToLocal()">
							<i class="fas fa-save mx-1"></i>
							<span title="Lưu lại trong Browser để lần sau xem hoặc sửa (bằng cách nhấn 'Import TKB')">
								Lưu trong Browser
							</span>
						</button>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import XLSX from 'xlsx';
import { contentHost } from '@/api/constant.js'

export default {
    data() {
        return {
            mobileSeeMoreCode: false,
            jsCodeForLocalStorage: "localStorage.getItem('timeTable')",
			tkbJson: '',
			host: contentHost,
        }
    },
    methods:{
        copy(text){ // on mobile must have https
			if (navigator?.clipboard?.writeText) {

				navigator.clipboard.writeText(text)
				this.$toast.success('Đã copy!')
			} else {
				this.$toast.error('Trình duyệt của bạn không cho phép trang web này copy text!')
			}
        },
		getJsonObject() {
			try {
				let o = JSON.parse(this.tkbJson)
				console.log(o)
				return o
			} catch(e) {
				console.log(this.tkbJson)
				this.$toast.error('Copy sai rồi.')
				throw e
			}
		},
		exportFile() {
            let result = this.getJsonObject()
            let workbook = XLSX.utils.book_new()
            let sheet = XLSX.utils.json_to_sheet(result)
            XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1')
            XLSX.writeFile(workbook, 'time-table.xlsx');
			this.$toast.success('Đã xuất file')
        },
		saveToLocal() {
            this.getJsonObject()
            localStorage.setItem('timeTable', this.tkbJson)
            this.hasLocalTimeTable = true
            this.$toast.success('Đã lưu vào bộ nhớ của Browser')
        },
    }
}
</script>

<style scoped>
    .nav-link{
        color: white;
    }
</style>